import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import customerShippingOptionsApi from "./api/customerShippingOptionsApi";
import { ChangeShippingOptions, CustomerShippingOptionsState } from "../shared/models/customerShippingOptions";

export const getShippingOptions = createAsyncThunk(
  "customerShippingOptions/getShippingOptions",
  async () => {
    return customerShippingOptionsApi.getShippingOptions();
  }
);

export const changeShippingOptions = createAsyncThunk(
  "customerShippingOptions/editContact",
  async (model: ChangeShippingOptions) => {
    return customerShippingOptionsApi.changeShippingOptions(model);
  }
);

const initialState: CustomerShippingOptionsState = {
  shippingOptions: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const customerShippingOptionsSlice = createSlice({
  name: "customerShippingOptions",
  initialState: initialState,
  reducers: {
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getShippingOptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShippingOptions.fulfilled, (state, { payload }) => {
        state.shippingOptions = payload;
        state.loading = false;
      })
      .addCase(getShippingOptions.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeShippingOptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeShippingOptions.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(changeShippingOptions.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  setSuccess,
  setLoading,
  setError
} = customerShippingOptionsSlice.actions;

export default customerShippingOptionsSlice.reducer;